import { render, staticRenderFns } from "./NotenruecknahmeSVModal.vue?vue&type=template&id=4349ff7f&"
import script from "./NotenruecknahmeSVModal.vue?vue&type=script&lang=js&"
export * from "./NotenruecknahmeSVModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports